import { NeauviaItem } from 'src/models/directus';
import { NotesTab } from 'src/modules/materials/components/MaterialPage/MaterialPageTabs/NotesTab';
import { DetailsTab } from 'src/modules/materials/components/MaterialPage/MaterialPageTabs/DetailsTab';
import { ProductsTab } from 'src/modules/materials/components/MaterialPage/MaterialPageTabs/ProductsTab';
import { UserNotesTab } from 'src/modules/materials/components/MaterialPage/MaterialPageTabs/UserNotesTab';
import {
  MaterialPageTab,
  MaterialPageTabId,
} from 'src/modules/materials/components/MaterialPage/MaterialPageTabs/types';

type TabsFactoryConfig = (
  | MaterialPageTabId
  | (Partial<Omit<MaterialPageTab, 'id'>> & {
      id: MaterialPageTabId;
      renderCondition?: (item?: NeauviaItem | null) => boolean;
    })
)[];

const tabConfigsMap: Partial<
  Record<
    MaterialPageTabId,
    Omit<MaterialPageTab, 'id'> & {
      renderCondition?: (item?: NeauviaItem | null) => boolean;
    }
  >
> = {
  [MaterialPageTabId.Notes]: {
    description: 'Files to download, links',
    Renderer: NotesTab,
    renderCondition: (item) =>
      !!(item && 'attachments' in item && item.attachments?.length > 0),
  },
  [MaterialPageTabId.UserNotes]: {
    title: 'NOTES',
    description: 'Add your notes',
    Renderer: UserNotesTab,
  },
  [MaterialPageTabId.Details]: {
    description: 'About the talk',
    Renderer: DetailsTab,
  },
  [MaterialPageTabId.Products]: {
    description: 'From this video',
    Renderer: ProductsTab,
    renderCondition: (item) =>
      !!(item && 'products' in item && item.products?.length > 0),
  },
};

export const tabsFactory =
  (item: NeauviaItem | null | undefined) =>
  (config: TabsFactoryConfig): MaterialPageTab<NeauviaItem>[] => {
    return config.reduce<MaterialPageTab<NeauviaItem>[]>((prev, tab) => {
      if (typeof tab === 'string') {
        const tabConfig = tabConfigsMap[tab];
        if (tabConfig && (tabConfig.renderCondition?.(item) ?? true)) {
          prev.push({ id: tab, ...tabConfig });
        }
      } else {
        const defaultConfig = tabConfigsMap[tab.id];
        const tabConfig = { ...defaultConfig, ...tab };

        if (tabConfig.renderCondition?.(item) ?? true) {
          prev.push(tabConfig as MaterialPageTab);
        }
      }

      return prev;
    }, []);
  };
